import { checkNextPage } from '@/shared/lib/utils/pagination'
import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import { MASS_PAYMENTS_RECIPIENTS_DISPATCHERS } from '@/shared/constants/store-constants/massPaymentsRecipients'
import { massPaymentsService } from '@/shared/services/mass-payments.service'

export default {
  onSearch({ commit, dispatch }, payload) {
    commit('SET_SEARCH', payload)
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.resetStore,
      { resetSort: false, resetTotal: false },
      { root: true }
    )
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.goToLoadRecipients,
      {},
      { root: true }
    )
  },

  resetSearch({ commit, dispatch }) {
    commit('RESET_SEARCH')
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.resetStore,
      { resetSort: false },
      { root: true }
    )
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.goToLoadRecipients,
      {},
      { root: true }
    )
  },

  resetStore({ commit }, { resetSort = true } = {}) {
    commit('RESET_STORE', { resetSort })
  },

  resetPage({ commit }) {
    commit('RESET_PAGE')
  },

  changePage({ commit, dispatch, state }) {
    if (checkNextPage(state.page, state.total, state.limit)) {
      commit('SET_PAGE', state.page + 1)

      dispatch(
        MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.goToLoadRecipients,
        {},
        { root: true }
      )
    }
  },

  onSelectSort({ commit, dispatch }, payload) {
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.resetStore,
      { resetSort: false, resetTotal: false },
      { root: true }
    )
    commit('SET_SORT', payload)
    dispatch(
      MASS_PAYMENTS_RECIPIENTS_DISPATCHERS.goToLoadRecipients,
      {},
      { root: true }
    )
  },

  async goToLoadRecipients({ commit, state, dispatch }, params) {
    try {
      commit('SET_LOADING', true)

      const response = await massPaymentsService.getRecipients({
        ...params,
        page: state.page,
        limit: state.limit,
        ...(state.search && { search: state.search }),
        sort_by: state.sort.sort_by,
        sort_direction: state.sort.sort_direction,
      })

      const data = response.data || {}
      const newRecipients = data.recipients || []

      const isFiltered = !!state.search
      commit('SET_ITEMS', {
        items: newRecipients,
        total: data.total || 0,
        ...(!isFiltered && { totalAll: data.total || 0 }),
        reset: state.page === 1,
      })
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
